import React from 'react';

import Loader from '../../../../../../../CommunityDashboard/components/CommunityDashboardPage/components/Loader/Loader';

import { COLORS } from '../../../../../../helpers/constants';
import getColorCode from '../../../../../../helpers/getColorCode';

import styles from './DeliveryPotential.module.css';

export default props => {
  const {
    totalSampleSize,
    maxDeliveryPotentialCount,
    totalSampleSizeLoading
  } = props;

  let color = null;
  if (
    (totalSampleSize || totalSampleSize === 0) &&
    (maxDeliveryPotentialCount || maxDeliveryPotentialCount === 0)
  ) {
    const deliveryFactor = maxDeliveryPotentialCount / totalSampleSize;
    color = getColorCode(deliveryFactor);
  }

  return (
    <div>
      <div className={styles.title}>Can we deliver?</div>
      <div className={styles.container}>
        <div
          className={`${styles.trafficLightContainer} ${
            totalSampleSizeLoading ||
            !(maxDeliveryPotentialCount || maxDeliveryPotentialCount === 0)
              ? styles.loadingTrafficLight
              : ''
          }`}
        >
          <div
            className={`${styles.light} ${styles.redLight} ${
              color === COLORS.RED && !totalSampleSizeLoading
                ? styles.active
                : ''
            }`}
          />
          <div
            className={`${styles.light} ${styles.orangeLight} ${
              color === COLORS.ORANGE && !totalSampleSizeLoading
                ? styles.active
                : ''
            }`}
          />
          <div
            className={`${styles.light} ${styles.greenLight} ${
              color === COLORS.GREEN && !totalSampleSizeLoading
                ? styles.active
                : ''
            }`}
          />
        </div>
        {maxDeliveryPotentialCount || maxDeliveryPotentialCount === 0 ? (
          <div className={styles.deliveryContainer}>
            <div className={styles.deliveryTitle}>Delivery potential</div>
            <div className={styles.mainContainer}>
              <div className={styles.maxDeliveryPotentialCount}>
                {maxDeliveryPotentialCount}
              </div>
              <div>
                <div>max amount of</div>
                <div>completes in 48h</div>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.deliveryContainer}>
            <div className={styles.loadingContainer}>
              <Loader fixed={false} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
